export const tableColumns = [
  {
    label: "工作表名称",
    value: "name"
  },
  {
    label: "创建人",
    value: "creator.name"
  },
  {
    label: "创建时间",
    value: "createAt"
  }
]

export const tableData = [
  {
    name: "工作表1",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表2",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表3",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表4",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表1",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表2",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表3",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表4",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表1",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表2",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表3",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表4",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表1",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表2",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表3",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表4",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表1",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表2",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表3",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表4",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表1",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表2",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表3",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  },
  {
    name: "工作表4",
    creator: "创建人",
    createAt: "创建时间",
    updateAt: "更新时间",
    status: "启用"
  }
]
